module.exports = "/_next/static/images/ico-cat-ec4f6daca64056ed0404089610854718.svg";